import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

/** Dark-UI mark (light colors) — also used as default browser tab icon */
const FAVICON_DARK = '/euroasiann-favicon-dark.png';
/** Light-UI mark (blue mark) */
const FAVICON_LIGHT = '/euroasiann-favicon-light.png';
const DASHBOARD_FAVICON = '/dashboard-favicon.png';

function setFavicon(href: string, type: string) {
  const selectors = ["link[rel='icon']", "link[rel='shortcut icon']"];

  for (const selector of selectors) {
    let link = document.querySelector<HTMLLinkElement>(selector);
    if (!link) {
      link = document.createElement('link');
      link.rel = selector.includes('shortcut') ? 'shortcut icon' : 'icon';
      document.head.appendChild(link);
    }
    link.type = type;
    // Bust browser favicon cache when switching routes/theme
    link.href = `${href}?v=${encodeURIComponent(href)}`;
  }
}

/** Theme-aware Euroasiann favicon; dashboard route uses the dedicated mark. */
export function useDashboardFavicon() {
  const { pathname } = useLocation();
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const isDashboard = pathname === '/dashboard' || pathname === '/dashboard/';
    if (isDashboard) {
      setFavicon(DASHBOARD_FAVICON, 'image/png');
      return;
    }

    const href = resolvedTheme === 'dark' ? FAVICON_DARK : FAVICON_LIGHT;
    setFavicon(href, 'image/png');
  }, [pathname, resolvedTheme]);
}
